export default "__VITE_ASSET__ByeO6DHu__"